// extracted by mini-css-extract-plugin
export default {"progress":"style_progress__lHacm","primarySizeProgress":"style_primarySizeProgress__YX6ma","defaultProgress":"style_defaultProgress__b+4jK"};